import { NgModule } from '@angular/core';
import { DynamicSoudotecEmplacementInputComponent } from './dynamic-soudotec-emplacement-input.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { DropdownModule } from '../../dropdown/dropdown.module';
import { KendoModule } from '../../kendo.module';
import { SoudotecEmplacementInputService } from './soudotec-emplacement-input.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FamocoScanLaserModule } from '../../famoco-scan-laser/famoco-scan-laser.module';
import { SoudotecEmplacementInputDesignComponent } from './emplacement-input-design/soudotec-emplacement-input-design.component';
import { SoudotecEmplacementInputFormComponent } from './emplacement-input-form/soudotec-emplacement-input-form.component';
import { SoudotecEmplacementInputResultComponent } from './emplacement-input-result/soudotec-emplacement-input-result.component';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
    declarations: [
        SoudotecEmplacementInputResultComponent,
        SoudotecEmplacementInputDesignComponent,
        SoudotecEmplacementInputFormComponent, DynamicSoudotecEmplacementInputComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        DropdownModule,
        KendoModule,
        FamocoScanLaserModule,
        NgxMatSelectSearchModule,
        ScrollingModule
    ],
    entryComponents: [
        DynamicSoudotecEmplacementInputComponent,
    ],
    providers: [
        SoudotecEmplacementInputService
    ]
})
export class SoudotecEmplacementInputModule {}